export default {
  name: "Carpet Cleaning Van Check",
  description: "Checklist for vans used by carpet cleaning teams — includes equipment condition.",
  required: ["Name", "LicensePlate", "Mileage"],
  fields: [
    { key: "Name", label: "Name", type: "text", required: true },
    { key: "Date", label: "Date", type: "date" },
    { key: "Department", label: "Department", type: "text" },
    { key: "LicensePlate", label: "Vehicle Number Plate", type: "text", required: true },
    { key: "Mileage", label: "Mileage", type: "number", required: true },
    { key: "Equipment", label: "Check Carpet Cleaning Machines", type: "text" },
    { key: "WaterTanks", label: "Water Tanks / Waste Tanks Condition", type: "text" },
    { key: "Cleanliness", label: "Cleanliness of Vehicle", type: "text" },
    { key: "Damage", label: "Any Visible Damage", type: "text" },
    { key: "Safety", label: "Safety Equipment Present (Gloves, Masks, etc.)", type: "text" },
    { key: "Notes", label: "Additional Notes", type: "textarea" }
  ],
  photos: true
};
